export default [
  {
    id: 32948906,
    node_id: 'MDEwOlJlcG9zaXRvcnkzMjk0ODkwNg==',
    name: 'AspectOrientedProgrammingWithUnity',
    full_name: 'Jalalx/AspectOrientedProgrammingWithUnity',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/AspectOrientedProgrammingWithUnity',
    description:
      'A NotifyPropertyChangedCallHandler implementation using Unity Interception',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity',
    forks_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/AspectOrientedProgrammingWithUnity/deployments',
    created_at: '2015-03-26T19:59:01Z',
    updated_at: '2021-07-27T14:08:42Z',
    pushed_at: '2015-04-10T06:19:53Z',
    git_url: 'git://github.com/Jalalx/AspectOrientedProgrammingWithUnity.git',
    ssh_url: 'git@github.com:Jalalx/AspectOrientedProgrammingWithUnity.git',
    clone_url:
      'https://github.com/Jalalx/AspectOrientedProgrammingWithUnity.git',
    svn_url: 'https://github.com/Jalalx/AspectOrientedProgrammingWithUnity',
    homepage:
      'http://khordady.blogspot.com/2015/03/notifypropertychanged-attribute-unity-di.html',
    size: 156,
    stargazers_count: 1,
    watchers_count: 1,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: 'master',
  },
  {
    id: 104133295,
    node_id: 'MDEwOlJlcG9zaXRvcnkxMDQxMzMyOTU=',
    name: 'call-recorder-for-android',
    full_name: 'Jalalx/call-recorder-for-android',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/call-recorder-for-android',
    description: 'call-recorder-for-android fork',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/call-recorder-for-android',
    forks_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/call-recorder-for-android/deployments',
    created_at: '2017-09-19T21:56:21Z',
    updated_at: '2017-09-19T21:56:22Z',
    pushed_at: '2017-05-29T15:38:42Z',
    git_url: 'git://github.com/Jalalx/call-recorder-for-android.git',
    ssh_url: 'git@github.com:Jalalx/call-recorder-for-android.git',
    clone_url: 'https://github.com/Jalalx/call-recorder-for-android.git',
    svn_url: 'https://github.com/Jalalx/call-recorder-for-android',
    homepage: '',
    size: 7628,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'Java',
    has_issues: false,
    has_projects: true,
    has_downloads: false,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 32325861,
    node_id: 'MDEwOlJlcG9zaXRvcnkzMjMyNTg2MQ==',
    name: 'CarPlateRecognizer',
    full_name: 'Jalalx/CarPlateRecognizer',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/CarPlateRecognizer',
    description:
      'A simple Car Plate Recognizer using Multi-Layer Perceptron Artificial Neural Network implemented in Matlab.',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/CarPlateRecognizer',
    forks_url: 'https://api.github.com/repos/Jalalx/CarPlateRecognizer/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/CarPlateRecognizer/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/CarPlateRecognizer/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/CarPlateRecognizer/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/CarPlateRecognizer/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/CarPlateRecognizer/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/CarPlateRecognizer/deployments',
    created_at: '2015-03-16T13:15:06Z',
    updated_at: '2015-03-16T13:38:08Z',
    pushed_at: '2015-03-16T13:36:49Z',
    git_url: 'git://github.com/Jalalx/CarPlateRecognizer.git',
    ssh_url: 'git@github.com:Jalalx/CarPlateRecognizer.git',
    clone_url: 'https://github.com/Jalalx/CarPlateRecognizer.git',
    svn_url: 'https://github.com/Jalalx/CarPlateRecognizer',
    homepage: '',
    size: 5096,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'Matlab',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'gpl-2.0',
      name: 'GNU General Public License v2.0',
      spdx_id: 'GPL-2.0',
      url: 'https://api.github.com/licenses/gpl-2.0',
      node_id: 'MDc6TGljZW5zZTg=',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 210021011,
    node_id: 'MDEwOlJlcG9zaXRvcnkyMTAwMjEwMTE=',
    name: 'coding-interview-university',
    full_name: 'Jalalx/coding-interview-university',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/coding-interview-university',
    description:
      'A complete computer science study plan to become a software engineer.',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/coding-interview-university',
    forks_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/coding-interview-university/deployments',
    created_at: '2019-09-21T16:49:43Z',
    updated_at: '2020-09-11T09:01:50Z',
    pushed_at: '2020-09-11T09:00:46Z',
    git_url: 'git://github.com/Jalalx/coding-interview-university.git',
    ssh_url: 'git@github.com:Jalalx/coding-interview-university.git',
    clone_url: 'https://github.com/Jalalx/coding-interview-university.git',
    svn_url: 'https://github.com/Jalalx/coding-interview-university',
    homepage: '',
    size: 9815,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'cc-by-sa-4.0',
      name: 'Creative Commons Attribution Share Alike 4.0 International',
      spdx_id: 'CC-BY-SA-4.0',
      url: 'https://api.github.com/licenses/cc-by-sa-4.0',
      node_id: 'MDc6TGljZW5zZTI2',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 390263159,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTAyNjMxNTk=',
    name: 'confluence-rtl-extension',
    full_name: 'Jalalx/confluence-rtl-extension',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/confluence-rtl-extension',
    description: 'An extension to make confluence pages RTL',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/confluence-rtl-extension',
    forks_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/confluence-rtl-extension/deployments',
    created_at: '2021-07-28T07:52:48Z',
    updated_at: '2021-07-28T09:51:14Z',
    pushed_at: '2021-07-28T09:12:40Z',
    git_url: 'git://github.com/Jalalx/confluence-rtl-extension.git',
    ssh_url: 'git@github.com:Jalalx/confluence-rtl-extension.git',
    clone_url: 'https://github.com/Jalalx/confluence-rtl-extension.git',
    svn_url: 'https://github.com/Jalalx/confluence-rtl-extension',
    homepage: '',
    size: 9,
    stargazers_count: 1,
    watchers_count: 1,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['chrome-extension', 'confluence', 'edge-extension', 'rtl'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: 'main',
  },
  {
    id: 389230283,
    node_id: 'MDEwOlJlcG9zaXRvcnkzODkyMzAyODM=',
    name: 'csharp-source-generators',
    full_name: 'Jalalx/csharp-source-generators',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/csharp-source-generators',
    description:
      'A list of C# Source Generators (not necessarily awesome) and associated resources: articles, talks, demos.',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/csharp-source-generators',
    forks_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/csharp-source-generators/deployments',
    created_at: '2021-07-25T01:02:42Z',
    updated_at: '2021-08-17T19:52:47Z',
    pushed_at: '2021-08-17T19:52:44Z',
    git_url: 'git://github.com/Jalalx/csharp-source-generators.git',
    ssh_url: 'git@github.com:Jalalx/csharp-source-generators.git',
    clone_url: 'https://github.com/Jalalx/csharp-source-generators.git',
    svn_url: 'https://github.com/Jalalx/csharp-source-generators',
    homepage: '',
    size: 185,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'cc0-1.0',
      name: 'Creative Commons Zero v1.0 Universal',
      spdx_id: 'CC0-1.0',
      url: 'https://api.github.com/licenses/cc0-1.0',
      node_id: 'MDc6TGljZW5zZTY=',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 86908983,
    node_id: 'MDEwOlJlcG9zaXRvcnk4NjkwODk4Mw==',
    name: 'deliciousfeed',
    full_name: 'Jalalx/deliciousfeed',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/deliciousfeed',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/deliciousfeed',
    forks_url: 'https://api.github.com/repos/Jalalx/deliciousfeed/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/deliciousfeed/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/deliciousfeed/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/deliciousfeed/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/deliciousfeed/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/deliciousfeed/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/deliciousfeed/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/deliciousfeed/deployments',
    created_at: '2017-04-01T11:29:30Z',
    updated_at: '2017-04-01T11:51:35Z',
    pushed_at: '2017-04-02T18:29:35Z',
    git_url: 'git://github.com/Jalalx/deliciousfeed.git',
    ssh_url: 'git@github.com:Jalalx/deliciousfeed.git',
    clone_url: 'https://github.com/Jalalx/deliciousfeed.git',
    svn_url: 'https://github.com/Jalalx/deliciousfeed',
    homepage: null,
    size: 17,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'heroku',
  },
  {
    id: 103590111,
    node_id: 'MDEwOlJlcG9zaXRvcnkxMDM1OTAxMTE=',
    name: 'drag',
    full_name: 'Jalalx/drag',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/drag',
    description: 'An Angular 4 drag and drop kanban board.',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/drag',
    forks_url: 'https://api.github.com/repos/Jalalx/drag/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/drag/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/drag/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/drag/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/drag/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/drag/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/drag/events',
    assignees_url: 'https://api.github.com/repos/Jalalx/drag/assignees{/user}',
    branches_url: 'https://api.github.com/repos/Jalalx/drag/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/drag/tags',
    blobs_url: 'https://api.github.com/repos/Jalalx/drag/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/Jalalx/drag/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/Jalalx/drag/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/Jalalx/drag/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/Jalalx/drag/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/drag/languages',
    stargazers_url: 'https://api.github.com/repos/Jalalx/drag/stargazers',
    contributors_url: 'https://api.github.com/repos/Jalalx/drag/contributors',
    subscribers_url: 'https://api.github.com/repos/Jalalx/drag/subscribers',
    subscription_url: 'https://api.github.com/repos/Jalalx/drag/subscription',
    commits_url: 'https://api.github.com/repos/Jalalx/drag/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/drag/git/commits{/sha}',
    comments_url: 'https://api.github.com/repos/Jalalx/drag/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/drag/issues/comments{/number}',
    contents_url: 'https://api.github.com/repos/Jalalx/drag/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/drag/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/drag/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/drag/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/drag/downloads',
    issues_url: 'https://api.github.com/repos/Jalalx/drag/issues{/number}',
    pulls_url: 'https://api.github.com/repos/Jalalx/drag/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/drag/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/drag/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/Jalalx/drag/labels{/name}',
    releases_url: 'https://api.github.com/repos/Jalalx/drag/releases{/id}',
    deployments_url: 'https://api.github.com/repos/Jalalx/drag/deployments',
    created_at: '2017-09-14T23:01:36Z',
    updated_at: '2021-12-05T19:21:19Z',
    pushed_at: '2017-09-14T23:04:27Z',
    git_url: 'git://github.com/Jalalx/drag.git',
    ssh_url: 'git@github.com:Jalalx/drag.git',
    clone_url: 'https://github.com/Jalalx/drag.git',
    svn_url: 'https://github.com/Jalalx/drag',
    homepage: null,
    size: 14,
    stargazers_count: 3,
    watchers_count: 3,
    language: 'TypeScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 2,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 2,
    open_issues: 0,
    watchers: 3,
    default_branch: 'master',
  },
  {
    id: 162038871,
    node_id: 'MDEwOlJlcG9zaXRvcnkxNjIwMzg4NzE=',
    name: 'DuplicateFinder',
    full_name: 'Jalalx/DuplicateFinder',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/DuplicateFinder',
    description:
      'A command line application that helps finding duplicate files in given directory.',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/DuplicateFinder',
    forks_url: 'https://api.github.com/repos/Jalalx/DuplicateFinder/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/DuplicateFinder/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/DuplicateFinder/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/DuplicateFinder/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/DuplicateFinder/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/DuplicateFinder/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/DuplicateFinder/deployments',
    created_at: '2018-12-16T20:37:57Z',
    updated_at: '2018-12-16T20:40:15Z',
    pushed_at: '2018-12-16T20:40:13Z',
    git_url: 'git://github.com/Jalalx/DuplicateFinder.git',
    ssh_url: 'git@github.com:Jalalx/DuplicateFinder.git',
    clone_url: 'https://github.com/Jalalx/DuplicateFinder.git',
    svn_url: 'https://github.com/Jalalx/DuplicateFinder',
    homepage: null,
    size: 6,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 230968813,
    node_id: 'MDEwOlJlcG9zaXRvcnkyMzA5Njg4MTM=',
    name: 'EPPlus',
    full_name: 'Jalalx/EPPlus',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/EPPlus',
    description: 'Create advanced Excel spreadsheets using .NET',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/EPPlus',
    forks_url: 'https://api.github.com/repos/Jalalx/EPPlus/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/EPPlus/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/EPPlus/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/EPPlus/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/EPPlus/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/EPPlus/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/EPPlus/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/EPPlus/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/EPPlus/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/EPPlus/tags',
    blobs_url: 'https://api.github.com/repos/Jalalx/EPPlus/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/Jalalx/EPPlus/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/Jalalx/EPPlus/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/Jalalx/EPPlus/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/Jalalx/EPPlus/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/EPPlus/languages',
    stargazers_url: 'https://api.github.com/repos/Jalalx/EPPlus/stargazers',
    contributors_url: 'https://api.github.com/repos/Jalalx/EPPlus/contributors',
    subscribers_url: 'https://api.github.com/repos/Jalalx/EPPlus/subscribers',
    subscription_url: 'https://api.github.com/repos/Jalalx/EPPlus/subscription',
    commits_url: 'https://api.github.com/repos/Jalalx/EPPlus/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/EPPlus/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/EPPlus/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/EPPlus/issues/comments{/number}',
    contents_url: 'https://api.github.com/repos/Jalalx/EPPlus/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/EPPlus/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/EPPlus/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/EPPlus/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/EPPlus/downloads',
    issues_url: 'https://api.github.com/repos/Jalalx/EPPlus/issues{/number}',
    pulls_url: 'https://api.github.com/repos/Jalalx/EPPlus/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/EPPlus/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/EPPlus/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/Jalalx/EPPlus/labels{/name}',
    releases_url: 'https://api.github.com/repos/Jalalx/EPPlus/releases{/id}',
    deployments_url: 'https://api.github.com/repos/Jalalx/EPPlus/deployments',
    created_at: '2019-12-30T19:28:34Z',
    updated_at: '2019-12-30T19:28:35Z',
    pushed_at: '2020-01-05T07:55:08Z',
    git_url: 'git://github.com/Jalalx/EPPlus.git',
    ssh_url: 'git@github.com:Jalalx/EPPlus.git',
    clone_url: 'https://github.com/Jalalx/EPPlus.git',
    svn_url: 'https://github.com/Jalalx/EPPlus',
    homepage: '',
    size: 13910,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 47814931,
    node_id: 'MDEwOlJlcG9zaXRvcnk0NzgxNDkzMQ==',
    name: 'FarsiToolbox',
    full_name: 'Jalalx/FarsiToolbox',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/FarsiToolbox',
    description: 'Provides basic development needs for Farsi language',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/FarsiToolbox',
    forks_url: 'https://api.github.com/repos/Jalalx/FarsiToolbox/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/FarsiToolbox/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/FarsiToolbox/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/FarsiToolbox/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/FarsiToolbox/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/FarsiToolbox/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/FarsiToolbox/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/FarsiToolbox/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/FarsiToolbox/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/FarsiToolbox/deployments',
    created_at: '2015-12-11T08:39:26Z',
    updated_at: '2017-11-22T07:46:34Z',
    pushed_at: '2017-11-22T07:46:32Z',
    git_url: 'git://github.com/Jalalx/FarsiToolbox.git',
    ssh_url: 'git@github.com:Jalalx/FarsiToolbox.git',
    clone_url: 'https://github.com/Jalalx/FarsiToolbox.git',
    svn_url: 'https://github.com/Jalalx/FarsiToolbox',
    homepage: '',
    size: 1994,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 66648388,
    node_id: 'MDEwOlJlcG9zaXRvcnk2NjY0ODM4OA==',
    name: 'feedit_bot',
    full_name: 'Jalalx/feedit_bot',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/feedit_bot',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/feedit_bot',
    forks_url: 'https://api.github.com/repos/Jalalx/feedit_bot/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/feedit_bot/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/feedit_bot/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/feedit_bot/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/feedit_bot/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/feedit_bot/tags',
    blobs_url: 'https://api.github.com/repos/Jalalx/feedit_bot/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/Jalalx/feedit_bot/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/feedit_bot/languages',
    stargazers_url: 'https://api.github.com/repos/Jalalx/feedit_bot/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/subscription',
    commits_url: 'https://api.github.com/repos/Jalalx/feedit_bot/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/feedit_bot/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/feedit_bot/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/issues{/number}',
    pulls_url: 'https://api.github.com/repos/Jalalx/feedit_bot/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/Jalalx/feedit_bot/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/feedit_bot/deployments',
    created_at: '2016-08-26T13:05:47Z',
    updated_at: '2016-08-26T13:16:19Z',
    pushed_at: '2016-08-26T13:26:29Z',
    git_url: 'git://github.com/Jalalx/feedit_bot.git',
    ssh_url: 'git@github.com:Jalalx/feedit_bot.git',
    clone_url: 'https://github.com/Jalalx/feedit_bot.git',
    svn_url: 'https://github.com/Jalalx/feedit_bot',
    homepage: null,
    size: 3928,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 123917844,
    node_id: 'MDEwOlJlcG9zaXRvcnkxMjM5MTc4NDQ=',
    name: 'FixDocType',
    full_name: 'Jalalx/FixDocType',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/FixDocType',
    description:
      'This command line tool fixes DOCPROEPRTY fields problem in MS Word 2010+ for PayamGostar application.',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/FixDocType',
    forks_url: 'https://api.github.com/repos/Jalalx/FixDocType/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/FixDocType/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/FixDocType/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/FixDocType/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/FixDocType/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/FixDocType/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/FixDocType/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/FixDocType/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/FixDocType/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/FixDocType/tags',
    blobs_url: 'https://api.github.com/repos/Jalalx/FixDocType/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/FixDocType/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/FixDocType/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/Jalalx/FixDocType/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/FixDocType/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/FixDocType/languages',
    stargazers_url: 'https://api.github.com/repos/Jalalx/FixDocType/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/FixDocType/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/FixDocType/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/FixDocType/subscription',
    commits_url: 'https://api.github.com/repos/Jalalx/FixDocType/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/FixDocType/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/FixDocType/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/FixDocType/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/FixDocType/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/FixDocType/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/FixDocType/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/FixDocType/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/FixDocType/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/FixDocType/issues{/number}',
    pulls_url: 'https://api.github.com/repos/Jalalx/FixDocType/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/FixDocType/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/FixDocType/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/Jalalx/FixDocType/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/FixDocType/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/FixDocType/deployments',
    created_at: '2018-03-05T12:42:35Z',
    updated_at: '2022-02-28T14:11:23Z',
    pushed_at: '2018-03-05T13:25:45Z',
    git_url: 'git://github.com/Jalalx/FixDocType.git',
    ssh_url: 'git@github.com:Jalalx/FixDocType.git',
    clone_url: 'https://github.com/Jalalx/FixDocType.git',
    svn_url: 'https://github.com/Jalalx/FixDocType',
    homepage: '',
    size: 9,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: true,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 389226912,
    node_id: 'MDEwOlJlcG9zaXRvcnkzODkyMjY5MTI=',
    name: 'HttpClientCodeGenerator',
    full_name: 'Jalalx/HttpClientCodeGenerator',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/HttpClientCodeGenerator',
    description:
      'HttpClientGenerator is a tool that uses the Roslyn code generator feature to write boilerplate HttpClient code for you.',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator',
    forks_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/HttpClientCodeGenerator/deployments',
    created_at: '2021-07-25T00:32:50Z',
    updated_at: '2022-06-26T21:55:31Z',
    pushed_at: '2021-09-09T18:54:52Z',
    git_url: 'git://github.com/Jalalx/HttpClientCodeGenerator.git',
    ssh_url: 'git@github.com:Jalalx/HttpClientCodeGenerator.git',
    clone_url: 'https://github.com/Jalalx/HttpClientCodeGenerator.git',
    svn_url: 'https://github.com/Jalalx/HttpClientCodeGenerator',
    homepage: '',
    size: 98,
    stargazers_count: 35,
    watchers_count: 35,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      'csharp-sourcegenerator',
      'httpclient',
      'roslyn-generator',
      'source-generator',
    ],
    visibility: 'public',
    forks: 1,
    open_issues: 1,
    watchers: 35,
    default_branch: 'main',
  },
  {
    id: 252738375,
    node_id: 'MDEwOlJlcG9zaXRvcnkyNTI3MzgzNzU=',
    name: 'iran-cities',
    full_name: 'Jalalx/iran-cities',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/iran-cities',
    description:
      'The most accurate database of city, county and province names of Iran.',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/iran-cities',
    forks_url: 'https://api.github.com/repos/Jalalx/iran-cities/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/iran-cities/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/iran-cities/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/iran-cities/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/iran-cities/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/iran-cities/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/iran-cities/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/iran-cities/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/iran-cities/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/iran-cities/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/iran-cities/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/iran-cities/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/iran-cities/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/iran-cities/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/iran-cities/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/iran-cities/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/iran-cities/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/iran-cities/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/iran-cities/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/iran-cities/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/iran-cities/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/iran-cities/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/iran-cities/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/iran-cities/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/iran-cities/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/iran-cities/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/iran-cities/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/iran-cities/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/iran-cities/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/iran-cities/issues{/number}',
    pulls_url: 'https://api.github.com/repos/Jalalx/iran-cities/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/iran-cities/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/iran-cities/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/Jalalx/iran-cities/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/iran-cities/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/iran-cities/deployments',
    created_at: '2020-04-03T13:22:20Z',
    updated_at: '2020-04-03T13:22:22Z',
    pushed_at: '2019-07-04T10:23:48Z',
    git_url: 'git://github.com/Jalalx/iran-cities.git',
    ssh_url: 'git@github.com:Jalalx/iran-cities.git',
    clone_url: 'https://github.com/Jalalx/iran-cities.git',
    svn_url: 'https://github.com/Jalalx/iran-cities',
    homepage: '',
    size: 66,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 336077833,
    node_id: 'MDEwOlJlcG9zaXRvcnkzMzYwNzc4MzM=',
    name: 'jalalx.github.io',
    full_name: 'Jalalx/jalalx.github.io',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/jalalx.github.io',
    description: 'The repository that hosts https://jalalamini.ir ',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/jalalx.github.io',
    forks_url: 'https://api.github.com/repos/Jalalx/jalalx.github.io/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/jalalx.github.io/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/jalalx.github.io/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/jalalx.github.io/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/jalalx.github.io/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/jalalx.github.io/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/jalalx.github.io/deployments',
    created_at: '2021-02-04T20:44:54Z',
    updated_at: '2021-07-13T17:43:07Z',
    pushed_at: '2021-07-13T17:23:54Z',
    git_url: 'git://github.com/Jalalx/jalalx.github.io.git',
    ssh_url: 'git@github.com:Jalalx/jalalx.github.io.git',
    clone_url: 'https://github.com/Jalalx/jalalx.github.io.git',
    svn_url: 'https://github.com/Jalalx/jalalx.github.io',
    homepage: 'https://jalalamini.ir ',
    size: 12281,
    stargazers_count: 1,
    watchers_count: 1,
    language: 'JavaScript',
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['blog', 'programming'],
    visibility: 'public',
    forks: 0,
    open_issues: 1,
    watchers: 1,
    default_branch: 'master',
  },
  {
    id: 88171298,
    node_id: 'MDEwOlJlcG9zaXRvcnk4ODE3MTI5OA==',
    name: 'KMeans',
    full_name: 'Jalalx/KMeans',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/KMeans',
    description: 'K-Means algorithm for data clustering.',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/KMeans',
    forks_url: 'https://api.github.com/repos/Jalalx/KMeans/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/KMeans/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/KMeans/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/KMeans/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/KMeans/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/KMeans/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/KMeans/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/KMeans/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/KMeans/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/KMeans/tags',
    blobs_url: 'https://api.github.com/repos/Jalalx/KMeans/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/Jalalx/KMeans/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/Jalalx/KMeans/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/Jalalx/KMeans/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/Jalalx/KMeans/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/KMeans/languages',
    stargazers_url: 'https://api.github.com/repos/Jalalx/KMeans/stargazers',
    contributors_url: 'https://api.github.com/repos/Jalalx/KMeans/contributors',
    subscribers_url: 'https://api.github.com/repos/Jalalx/KMeans/subscribers',
    subscription_url: 'https://api.github.com/repos/Jalalx/KMeans/subscription',
    commits_url: 'https://api.github.com/repos/Jalalx/KMeans/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/KMeans/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/KMeans/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/KMeans/issues/comments{/number}',
    contents_url: 'https://api.github.com/repos/Jalalx/KMeans/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/KMeans/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/KMeans/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/KMeans/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/KMeans/downloads',
    issues_url: 'https://api.github.com/repos/Jalalx/KMeans/issues{/number}',
    pulls_url: 'https://api.github.com/repos/Jalalx/KMeans/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/KMeans/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/KMeans/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/Jalalx/KMeans/labels{/name}',
    releases_url: 'https://api.github.com/repos/Jalalx/KMeans/releases{/id}',
    deployments_url: 'https://api.github.com/repos/Jalalx/KMeans/deployments',
    created_at: '2017-04-13T14:04:30Z',
    updated_at: '2017-04-13T15:00:14Z',
    pushed_at: '2017-04-13T14:50:42Z',
    git_url: 'git://github.com/Jalalx/KMeans.git',
    ssh_url: 'git@github.com:Jalalx/KMeans.git',
    clone_url: 'https://github.com/Jalalx/KMeans.git',
    svn_url: 'https://github.com/Jalalx/KMeans',
    homepage: null,
    size: 5,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['csharp', 'data-clustering', 'k-means'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 160253000,
    node_id: 'MDEwOlJlcG9zaXRvcnkxNjAyNTMwMDA=',
    name: 'LhsBracketParser',
    full_name: 'Jalalx/LhsBracketParser',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/LhsBracketParser',
    description: 'A basic LHS Bracket parser in C#',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/LhsBracketParser',
    forks_url: 'https://api.github.com/repos/Jalalx/LhsBracketParser/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/LhsBracketParser/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/LhsBracketParser/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/LhsBracketParser/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/LhsBracketParser/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/LhsBracketParser/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/LhsBracketParser/deployments',
    created_at: '2018-12-03T20:59:11Z',
    updated_at: '2021-09-16T13:45:50Z',
    pushed_at: '2018-12-23T20:17:21Z',
    git_url: 'git://github.com/Jalalx/LhsBracketParser.git',
    ssh_url: 'git@github.com:Jalalx/LhsBracketParser.git',
    clone_url: 'https://github.com/Jalalx/LhsBracketParser.git',
    svn_url: 'https://github.com/Jalalx/LhsBracketParser',
    homepage: '',
    size: 62,
    stargazers_count: 4,
    watchers_count: 4,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 4,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['lhs-bracket', 'parser', 'predicate', 'predicatebuilder'],
    visibility: 'public',
    forks: 4,
    open_issues: 0,
    watchers: 4,
    default_branch: 'master',
  },
  {
    id: 103027005,
    node_id: 'MDEwOlJlcG9zaXRvcnkxMDMwMjcwMDU=',
    name: 'Nop.Plugin.Payments.MellatBank',
    full_name: 'Jalalx/Nop.Plugin.Payments.MellatBank',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/Nop.Plugin.Payments.MellatBank',
    description:
      'nopCommerce plugin for MellatBank (payments) درگاه پرداخت بانک ملت ',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank',
    forks_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/Nop.Plugin.Payments.MellatBank/deployments',
    created_at: '2017-09-10T12:18:43Z',
    updated_at: '2017-09-10T12:18:45Z',
    pushed_at: '2017-09-05T07:24:31Z',
    git_url: 'git://github.com/Jalalx/Nop.Plugin.Payments.MellatBank.git',
    ssh_url: 'git@github.com:Jalalx/Nop.Plugin.Payments.MellatBank.git',
    clone_url: 'https://github.com/Jalalx/Nop.Plugin.Payments.MellatBank.git',
    svn_url: 'https://github.com/Jalalx/Nop.Plugin.Payments.MellatBank',
    homepage: null,
    size: 213,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 1,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 120059876,
    node_id: 'MDEwOlJlcG9zaXRvcnkxMjAwNTk4NzY=',
    name: 'PardakhtVasetClient',
    full_name: 'Jalalx/PardakhtVasetClient',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/PardakhtVasetClient',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/PardakhtVasetClient',
    forks_url: 'https://api.github.com/repos/Jalalx/PardakhtVasetClient/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/PardakhtVasetClient/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/PardakhtVasetClient/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/PardakhtVasetClient/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/PardakhtVasetClient/deployments',
    created_at: '2018-02-03T04:40:15Z',
    updated_at: '2018-04-23T13:17:22Z',
    pushed_at: '2018-04-23T13:17:20Z',
    git_url: 'git://github.com/Jalalx/PardakhtVasetClient.git',
    ssh_url: 'git@github.com:Jalalx/PardakhtVasetClient.git',
    clone_url: 'https://github.com/Jalalx/PardakhtVasetClient.git',
    svn_url: 'https://github.com/Jalalx/PardakhtVasetClient',
    homepage: 'http://pardakhtvaset.com/',
    size: 74,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['payment', 'payment-gateway'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 198996529,
    node_id: 'MDEwOlJlcG9zaXRvcnkxOTg5OTY1Mjk=',
    name: 'PersianStemmer-CSharp',
    full_name: 'Jalalx/PersianStemmer-CSharp',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/PersianStemmer-CSharp',
    description:
      'A .NET Core 2.2 implementation of original PersianStemmer-CSharp project.',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp',
    forks_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/PersianStemmer-CSharp/deployments',
    created_at: '2019-07-26T10:19:20Z',
    updated_at: '2019-07-26T20:05:32Z',
    pushed_at: '2019-07-26T20:05:31Z',
    git_url: 'git://github.com/Jalalx/PersianStemmer-CSharp.git',
    ssh_url: 'git@github.com:Jalalx/PersianStemmer-CSharp.git',
    clone_url: 'https://github.com/Jalalx/PersianStemmer-CSharp.git',
    svn_url: 'https://github.com/Jalalx/PersianStemmer-CSharp',
    homepage: '',
    size: 1060,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'bsd-2-clause',
      name: 'BSD 2-Clause "Simplified" License',
      spdx_id: 'BSD-2-Clause',
      url: 'https://api.github.com/licenses/bsd-2-clause',
      node_id: 'MDc6TGljZW5zZTQ=',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['csharp', 'dotnet-core', 'persian-nlp', 'stemmer'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 344760389,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNDQ3NjAzODk=',
    name: 'phony',
    full_name: 'Jalalx/phony',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/phony',
    description: 'Tiny command line fake data generator.',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/phony',
    forks_url: 'https://api.github.com/repos/Jalalx/phony/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/phony/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/phony/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/phony/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/phony/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/phony/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/phony/events',
    assignees_url: 'https://api.github.com/repos/Jalalx/phony/assignees{/user}',
    branches_url: 'https://api.github.com/repos/Jalalx/phony/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/phony/tags',
    blobs_url: 'https://api.github.com/repos/Jalalx/phony/git/blobs{/sha}',
    git_tags_url: 'https://api.github.com/repos/Jalalx/phony/git/tags{/sha}',
    git_refs_url: 'https://api.github.com/repos/Jalalx/phony/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/Jalalx/phony/git/trees{/sha}',
    statuses_url: 'https://api.github.com/repos/Jalalx/phony/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/phony/languages',
    stargazers_url: 'https://api.github.com/repos/Jalalx/phony/stargazers',
    contributors_url: 'https://api.github.com/repos/Jalalx/phony/contributors',
    subscribers_url: 'https://api.github.com/repos/Jalalx/phony/subscribers',
    subscription_url: 'https://api.github.com/repos/Jalalx/phony/subscription',
    commits_url: 'https://api.github.com/repos/Jalalx/phony/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/phony/git/commits{/sha}',
    comments_url: 'https://api.github.com/repos/Jalalx/phony/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/phony/issues/comments{/number}',
    contents_url: 'https://api.github.com/repos/Jalalx/phony/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/phony/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/phony/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/phony/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/phony/downloads',
    issues_url: 'https://api.github.com/repos/Jalalx/phony/issues{/number}',
    pulls_url: 'https://api.github.com/repos/Jalalx/phony/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/phony/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/phony/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/Jalalx/phony/labels{/name}',
    releases_url: 'https://api.github.com/repos/Jalalx/phony/releases{/id}',
    deployments_url: 'https://api.github.com/repos/Jalalx/phony/deployments',
    created_at: '2021-03-05T09:31:35Z',
    updated_at: '2021-03-05T11:46:43Z',
    pushed_at: '2021-03-05T11:46:41Z',
    git_url: 'git://github.com/Jalalx/phony.git',
    ssh_url: 'git@github.com:Jalalx/phony.git',
    clone_url: 'https://github.com/Jalalx/phony.git',
    svn_url: 'https://github.com/Jalalx/phony',
    homepage: '',
    size: 59,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'Go',
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 7803337,
    node_id: 'MDEwOlJlcG9zaXRvcnk3ODAzMzM3',
    name: 'PrismAppTutorials',
    full_name: 'Jalalx/PrismAppTutorials',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/PrismAppTutorials',
    description: 'Read more at: http://khordady.blogspot.de/2013/01/prism.html',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/PrismAppTutorials',
    forks_url: 'https://api.github.com/repos/Jalalx/PrismAppTutorials/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/PrismAppTutorials/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/PrismAppTutorials/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/PrismAppTutorials/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/PrismAppTutorials/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/PrismAppTutorials/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/PrismAppTutorials/deployments',
    created_at: '2013-01-24T17:35:06Z',
    updated_at: '2013-11-02T01:38:11Z',
    pushed_at: '2013-02-01T22:29:14Z',
    git_url: 'git://github.com/Jalalx/PrismAppTutorials.git',
    ssh_url: 'git@github.com:Jalalx/PrismAppTutorials.git',
    clone_url: 'https://github.com/Jalalx/PrismAppTutorials.git',
    svn_url: 'https://github.com/Jalalx/PrismAppTutorials',
    homepage: null,
    size: 1648,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 113292393,
    node_id: 'MDEwOlJlcG9zaXRvcnkxMTMyOTIzOTM=',
    name: 'QueryExpressMod',
    full_name: 'Jalalx/QueryExpressMod',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/QueryExpressMod',
    description:
      'A small utility to query data in production environment. Query Express requires no installation and is packaged as a single ~1MB executable.',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/QueryExpressMod',
    forks_url: 'https://api.github.com/repos/Jalalx/QueryExpressMod/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/QueryExpressMod/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/QueryExpressMod/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/QueryExpressMod/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/QueryExpressMod/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/QueryExpressMod/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/QueryExpressMod/deployments',
    created_at: '2017-12-06T08:55:59Z',
    updated_at: '2018-01-27T09:24:31Z',
    pushed_at: '2017-12-08T13:02:04Z',
    git_url: 'git://github.com/Jalalx/QueryExpressMod.git',
    ssh_url: 'git@github.com:Jalalx/QueryExpressMod.git',
    clone_url: 'https://github.com/Jalalx/QueryExpressMod.git',
    svn_url: 'https://github.com/Jalalx/QueryExpressMod',
    homepage: '',
    size: 975,
    stargazers_count: 1,
    watchers_count: 1,
    language: 'C#',
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['csharp', 'oracle', 'query', 'sql-server'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: 'master',
  },
  {
    id: 393934301,
    node_id: 'MDEwOlJlcG9zaXRvcnkzOTM5MzQzMDE=',
    name: 'rabbitmq-dotnet-client',
    full_name: 'Jalalx/rabbitmq-dotnet-client',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/rabbitmq-dotnet-client',
    description: 'RabbitMQ .NET client for .NET Standard 2.0+ and .NET 4.6.1+',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client',
    forks_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/rabbitmq-dotnet-client/deployments',
    created_at: '2021-08-08T10:50:39Z',
    updated_at: '2021-08-08T10:50:40Z',
    pushed_at: '2022-04-09T17:34:41Z',
    git_url: 'git://github.com/Jalalx/rabbitmq-dotnet-client.git',
    ssh_url: 'git@github.com:Jalalx/rabbitmq-dotnet-client.git',
    clone_url: 'https://github.com/Jalalx/rabbitmq-dotnet-client.git',
    svn_url: 'https://github.com/Jalalx/rabbitmq-dotnet-client',
    homepage: 'https://www.rabbitmq.com/dotnet.html',
    size: 46513,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'other',
      name: 'Other',
      spdx_id: 'NOASSERTION',
      url: null,
      node_id: 'MDc6TGljZW5zZTA=',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 363326991,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNjMzMjY5OTE=',
    name: 'roslyn-sdk',
    full_name: 'Jalalx/roslyn-sdk',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/roslyn-sdk',
    description: 'Roslyn-SDK templates and Syntax Visualizer',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/roslyn-sdk',
    forks_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/tags',
    blobs_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/languages',
    stargazers_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/subscription',
    commits_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/issues{/number}',
    pulls_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/Jalalx/roslyn-sdk/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/roslyn-sdk/deployments',
    created_at: '2021-05-01T05:03:03Z',
    updated_at: '2021-05-01T05:03:04Z',
    pushed_at: '2021-05-01T03:02:36Z',
    git_url: 'git://github.com/Jalalx/roslyn-sdk.git',
    ssh_url: 'git@github.com:Jalalx/roslyn-sdk.git',
    clone_url: 'https://github.com/Jalalx/roslyn-sdk.git',
    svn_url: 'https://github.com/Jalalx/roslyn-sdk',
    homepage: '',
    size: 2912,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 252784523,
    node_id: 'MDEwOlJlcG9zaXRvcnkyNTI3ODQ1MjM=',
    name: 'SampleGithubActionApp',
    full_name: 'Jalalx/SampleGithubActionApp',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/SampleGithubActionApp',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/SampleGithubActionApp',
    forks_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/SampleGithubActionApp/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/SampleGithubActionApp/deployments',
    created_at: '2020-04-03T16:29:54Z',
    updated_at: '2020-04-04T17:19:14Z',
    pushed_at: '2020-04-03T17:01:21Z',
    git_url: 'git://github.com/Jalalx/SampleGithubActionApp.git',
    ssh_url: 'git@github.com:Jalalx/SampleGithubActionApp.git',
    clone_url: 'https://github.com/Jalalx/SampleGithubActionApp.git',
    svn_url: 'https://github.com/Jalalx/SampleGithubActionApp',
    homepage: null,
    size: 14,
    stargazers_count: 1,
    watchers_count: 1,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'apache-2.0',
      name: 'Apache License 2.0',
      spdx_id: 'Apache-2.0',
      url: 'https://api.github.com/licenses/apache-2.0',
      node_id: 'MDc6TGljZW5zZTI=',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: 'master',
  },
  {
    id: 66188845,
    node_id: 'MDEwOlJlcG9zaXRvcnk2NjE4ODg0NQ==',
    name: 'SampleTelegramBotBackend',
    full_name: 'Jalalx/SampleTelegramBotBackend',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/SampleTelegramBotBackend',
    description: 'A simple node js backed telegram bot.',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend',
    forks_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/SampleTelegramBotBackend/deployments',
    created_at: '2016-08-21T08:33:21Z',
    updated_at: '2017-10-29T21:13:06Z',
    pushed_at: '2016-08-21T08:35:11Z',
    git_url: 'git://github.com/Jalalx/SampleTelegramBotBackend.git',
    ssh_url: 'git@github.com:Jalalx/SampleTelegramBotBackend.git',
    clone_url: 'https://github.com/Jalalx/SampleTelegramBotBackend.git',
    svn_url: 'https://github.com/Jalalx/SampleTelegramBotBackend',
    homepage: '',
    size: 1643,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 244445718,
    node_id: 'MDEwOlJlcG9zaXRvcnkyNDQ0NDU3MTg=',
    name: 'ServiceProviderClosedPartialTypeSupport',
    full_name: 'Jalalx/ServiceProviderClosedPartialTypeSupport',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url:
      'https://github.com/Jalalx/ServiceProviderClosedPartialTypeSupport',
    description:
      'A bug reproduce: https://github.com/dotnet/aspnetcore/issues/19507 ',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport',
    forks_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/ServiceProviderClosedPartialTypeSupport/deployments',
    created_at: '2020-03-02T18:33:36Z',
    updated_at: '2020-03-02T18:37:51Z',
    pushed_at: '2020-03-02T18:37:49Z',
    git_url:
      'git://github.com/Jalalx/ServiceProviderClosedPartialTypeSupport.git',
    ssh_url:
      'git@github.com:Jalalx/ServiceProviderClosedPartialTypeSupport.git',
    clone_url:
      'https://github.com/Jalalx/ServiceProviderClosedPartialTypeSupport.git',
    svn_url:
      'https://github.com/Jalalx/ServiceProviderClosedPartialTypeSupport',
    homepage: null,
    size: 5,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 173916821,
    node_id: 'MDEwOlJlcG9zaXRvcnkxNzM5MTY4MjE=',
    name: 'SharedConditionalLock',
    full_name: 'Jalalx/SharedConditionalLock',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/SharedConditionalLock',
    description: 'An In-Process shared conditional lock implementation',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/SharedConditionalLock',
    forks_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/SharedConditionalLock/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/SharedConditionalLock/deployments',
    created_at: '2019-03-05T09:32:47Z',
    updated_at: '2019-03-06T05:52:34Z',
    pushed_at: '2019-03-06T04:19:31Z',
    git_url: 'git://github.com/Jalalx/SharedConditionalLock.git',
    ssh_url: 'git@github.com:Jalalx/SharedConditionalLock.git',
    clone_url: 'https://github.com/Jalalx/SharedConditionalLock.git',
    svn_url: 'https://github.com/Jalalx/SharedConditionalLock',
    homepage: '',
    size: 9,
    stargazers_count: 1,
    watchers_count: 1,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['concurrency-patterns', 'csharp', 'multithreading'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: 'master',
  },
  {
    id: 80708970,
    node_id: 'MDEwOlJlcG9zaXRvcnk4MDcwODk3MA==',
    name: 'SignalRConnectionLimitIssue',
    full_name: 'Jalalx/SignalRConnectionLimitIssue',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/SignalRConnectionLimitIssue',
    description:
      'This repository shows limitation of concurrent connections in browsers using SignalR.',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue',
    forks_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/teams',
    hooks_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/SignalRConnectionLimitIssue/deployments',
    created_at: '2017-02-02T09:05:35Z',
    updated_at: '2017-02-02T09:05:50Z',
    pushed_at: '2017-02-03T15:21:50Z',
    git_url: 'git://github.com/Jalalx/SignalRConnectionLimitIssue.git',
    ssh_url: 'git@github.com:Jalalx/SignalRConnectionLimitIssue.git',
    clone_url: 'https://github.com/Jalalx/SignalRConnectionLimitIssue.git',
    svn_url: 'https://github.com/Jalalx/SignalRConnectionLimitIssue',
    homepage: null,
    size: 414,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['asp-mvc', 'concurrent-connection', 'csharp', 'signalr'],
    visibility: 'public',
    forks: 1,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 37257148,
    node_id: 'MDEwOlJlcG9zaXRvcnkzNzI1NzE0OA==',
    name: 'SqlServerError8621',
    full_name: 'Jalalx/SqlServerError8621',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/SqlServerError8621',
    description: 'Raise SQL Server error number 8621 ',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/SqlServerError8621',
    forks_url: 'https://api.github.com/repos/Jalalx/SqlServerError8621/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/SqlServerError8621/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/SqlServerError8621/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/SqlServerError8621/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/SqlServerError8621/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/SqlServerError8621/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/SqlServerError8621/deployments',
    created_at: '2015-06-11T11:28:45Z',
    updated_at: '2015-06-11T11:36:03Z',
    pushed_at: '2015-06-11T11:34:13Z',
    git_url: 'git://github.com/Jalalx/SqlServerError8621.git',
    ssh_url: 'git@github.com:Jalalx/SqlServerError8621.git',
    clone_url: 'https://github.com/Jalalx/SqlServerError8621.git',
    svn_url: 'https://github.com/Jalalx/SqlServerError8621',
    homepage: '',
    size: 132,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 328356555,
    node_id: 'MDEwOlJlcG9zaXRvcnkzMjgzNTY1NTU=',
    name: 'StackExchange.Redis',
    full_name: 'Jalalx/StackExchange.Redis',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/StackExchange.Redis',
    description: 'General purpose redis client',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/StackExchange.Redis',
    forks_url: 'https://api.github.com/repos/Jalalx/StackExchange.Redis/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/StackExchange.Redis/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/StackExchange.Redis/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/StackExchange.Redis/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/StackExchange.Redis/deployments',
    created_at: '2021-01-10T10:29:40Z',
    updated_at: '2021-01-10T10:29:41Z',
    pushed_at: '2021-01-17T10:49:24Z',
    git_url: 'git://github.com/Jalalx/StackExchange.Redis.git',
    ssh_url: 'git@github.com:Jalalx/StackExchange.Redis.git',
    clone_url: 'https://github.com/Jalalx/StackExchange.Redis.git',
    svn_url: 'https://github.com/Jalalx/StackExchange.Redis',
    homepage: 'https://stackexchange.github.io/StackExchange.Redis/',
    size: 24585,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'other',
      name: 'Other',
      spdx_id: 'NOASSERTION',
      url: null,
      node_id: 'MDc6TGljZW5zZTA=',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 160863999,
    node_id: 'MDEwOlJlcG9zaXRvcnkxNjA4NjM5OTk=',
    name: 'TimeScaleParser',
    full_name: 'Jalalx/TimeScaleParser',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/TimeScaleParser',
    description: 'Simple Time Scale Parser',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/TimeScaleParser',
    forks_url: 'https://api.github.com/repos/Jalalx/TimeScaleParser/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/TimeScaleParser/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/TimeScaleParser/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/TimeScaleParser/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/TimeScaleParser/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/TimeScaleParser/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/TimeScaleParser/deployments',
    created_at: '2018-12-07T18:58:32Z',
    updated_at: '2018-12-07T18:58:38Z',
    pushed_at: '2018-12-07T18:58:37Z',
    git_url: 'git://github.com/Jalalx/TimeScaleParser.git',
    ssh_url: 'git@github.com:Jalalx/TimeScaleParser.git',
    clone_url: 'https://github.com/Jalalx/TimeScaleParser.git',
    svn_url: 'https://github.com/Jalalx/TimeScaleParser',
    homepage: null,
    size: 10,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 70108176,
    node_id: 'MDEwOlJlcG9zaXRvcnk3MDEwODE3Ng==',
    name: 'TimeSpan.js',
    full_name: 'Jalalx/TimeSpan.js',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/TimeSpan.js',
    description: 'A tiny timespan plugin with jQuery support.',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/TimeSpan.js',
    forks_url: 'https://api.github.com/repos/Jalalx/TimeSpan.js/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/TimeSpan.js/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/TimeSpan.js/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/TimeSpan.js/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/TimeSpan.js/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/TimeSpan.js/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/TimeSpan.js/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/TimeSpan.js/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/TimeSpan.js/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/issues{/number}',
    pulls_url: 'https://api.github.com/repos/Jalalx/TimeSpan.js/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/Jalalx/TimeSpan.js/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/TimeSpan.js/deployments',
    created_at: '2016-10-05T23:41:22Z',
    updated_at: '2016-10-05T23:54:32Z',
    pushed_at: '2016-10-05T23:53:18Z',
    git_url: 'git://github.com/Jalalx/TimeSpan.js.git',
    ssh_url: 'git@github.com:Jalalx/TimeSpan.js.git',
    clone_url: 'https://github.com/Jalalx/TimeSpan.js.git',
    svn_url: 'https://github.com/Jalalx/TimeSpan.js',
    homepage: '',
    size: 51,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 1,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 42296207,
    node_id: 'MDEwOlJlcG9zaXRvcnk0MjI5NjIwNw==',
    name: 'TinyInterceptor',
    full_name: 'Jalalx/TinyInterceptor',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/TinyInterceptor',
    description: 'A tiny interceptor just to show how an interceptor works.',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/TinyInterceptor',
    forks_url: 'https://api.github.com/repos/Jalalx/TinyInterceptor/forks',
    keys_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/TinyInterceptor/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/TinyInterceptor/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/TinyInterceptor/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/TinyInterceptor/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/TinyInterceptor/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/TinyInterceptor/deployments',
    created_at: '2015-09-11T08:13:52Z',
    updated_at: '2022-06-08T09:19:15Z',
    pushed_at: '2016-07-25T19:35:21Z',
    git_url: 'git://github.com/Jalalx/TinyInterceptor.git',
    ssh_url: 'git@github.com:Jalalx/TinyInterceptor.git',
    clone_url: 'https://github.com/Jalalx/TinyInterceptor.git',
    svn_url: 'https://github.com/Jalalx/TinyInterceptor',
    homepage: 'http://khordady.blogspot.com',
    size: 11,
    stargazers_count: 5,
    watchers_count: 5,
    language: 'C#',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 6,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['csharp', 'intercept-calls', 'interceptor'],
    visibility: 'public',
    forks: 6,
    open_issues: 0,
    watchers: 5,
    default_branch: 'master',
  },
  {
    id: 231185496,
    node_id: 'MDEwOlJlcG9zaXRvcnkyMzExODU0OTY=',
    name: 'vue-chimera',
    full_name: 'Jalalx/vue-chimera',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/vue-chimera',
    description: 'VueJS RESTful client with reactive resources and endpoints.',
    fork: true,
    url: 'https://api.github.com/repos/Jalalx/vue-chimera',
    forks_url: 'https://api.github.com/repos/Jalalx/vue-chimera/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/vue-chimera/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/vue-chimera/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/vue-chimera/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/vue-chimera/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/vue-chimera/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/vue-chimera/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/vue-chimera/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/vue-chimera/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/issues{/number}',
    pulls_url: 'https://api.github.com/repos/Jalalx/vue-chimera/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/Jalalx/vue-chimera/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/vue-chimera/deployments',
    created_at: '2020-01-01T07:01:02Z',
    updated_at: '2020-01-01T07:01:05Z',
    pushed_at: '2019-04-20T13:47:25Z',
    git_url: 'git://github.com/Jalalx/vue-chimera.git',
    ssh_url: 'git@github.com:Jalalx/vue-chimera.git',
    clone_url: 'https://github.com/Jalalx/vue-chimera.git',
    svn_url: 'https://github.com/Jalalx/vue-chimera',
    homepage: '',
    size: 1582,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 320635438,
    node_id: 'MDEwOlJlcG9zaXRvcnkzMjA2MzU0Mzg=',
    name: 'ZeusCaching',
    full_name: 'Jalalx/ZeusCaching',
    private: false,
    owner: {
      login: 'Jalalx',
      id: 1018975,
      node_id: 'MDQ6VXNlcjEwMTg5NzU=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1018975?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/Jalalx',
      html_url: 'https://github.com/Jalalx',
      followers_url: 'https://api.github.com/users/Jalalx/followers',
      following_url:
        'https://api.github.com/users/Jalalx/following{/other_user}',
      gists_url: 'https://api.github.com/users/Jalalx/gists{/gist_id}',
      starred_url: 'https://api.github.com/users/Jalalx/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/Jalalx/subscriptions',
      organizations_url: 'https://api.github.com/users/Jalalx/orgs',
      repos_url: 'https://api.github.com/users/Jalalx/repos',
      events_url: 'https://api.github.com/users/Jalalx/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/Jalalx/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/Jalalx/ZeusCaching',
    description:
      'Zeus Caching simplifies using existing dotnet caching extensions in your ASP.NET Core Web API applications.',
    fork: false,
    url: 'https://api.github.com/repos/Jalalx/ZeusCaching',
    forks_url: 'https://api.github.com/repos/Jalalx/ZeusCaching/forks',
    keys_url: 'https://api.github.com/repos/Jalalx/ZeusCaching/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/Jalalx/ZeusCaching/teams',
    hooks_url: 'https://api.github.com/repos/Jalalx/ZeusCaching/hooks',
    issue_events_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/issues/events{/number}',
    events_url: 'https://api.github.com/repos/Jalalx/ZeusCaching/events',
    assignees_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/branches{/branch}',
    tags_url: 'https://api.github.com/repos/Jalalx/ZeusCaching/tags',
    blobs_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/Jalalx/ZeusCaching/languages',
    stargazers_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/stargazers',
    contributors_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/contributors',
    subscribers_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/subscribers',
    subscription_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/subscription',
    commits_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/Jalalx/ZeusCaching/merges',
    archive_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/Jalalx/ZeusCaching/downloads',
    issues_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/issues{/number}',
    pulls_url: 'https://api.github.com/repos/Jalalx/ZeusCaching/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/Jalalx/ZeusCaching/labels{/name}',
    releases_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/Jalalx/ZeusCaching/deployments',
    created_at: '2020-12-11T17:07:01Z',
    updated_at: '2021-04-24T13:05:49Z',
    pushed_at: '2021-04-25T13:05:06Z',
    git_url: 'git://github.com/Jalalx/ZeusCaching.git',
    ssh_url: 'git@github.com:Jalalx/ZeusCaching.git',
    clone_url: 'https://github.com/Jalalx/ZeusCaching.git',
    svn_url: 'https://github.com/Jalalx/ZeusCaching',
    homepage: '',
    size: 48,
    stargazers_count: 1,
    watchers_count: 1,
    language: 'C#',
    has_issues: true,
    has_projects: false,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: {
      key: 'apache-2.0',
      name: 'Apache License 2.0',
      spdx_id: 'Apache-2.0',
      url: 'https://api.github.com/licenses/apache-2.0',
      node_id: 'MDc6TGljZW5zZTI=',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['aspnetcore', 'cache', 'caching', 'web-api'],
    visibility: 'public',
    forks: 1,
    open_issues: 1,
    watchers: 1,
    default_branch: 'master',
  },
];
